import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/materias.css";
import MateriasSummary from "../components/MateriasSummary";
import MateriasList from "../components/MateriasList";
import MateriasFormModal from "../components/MateriasFormModal";
import CoordinacionTabs from "../../catalogo/components/CoordinacionTabs";
import useMateriaLogic from "../hooks/useMateriaLogic";
import { usePermissions } from "../../../../utils/permissions";

export default function MateriasView() {
  const { hasPermission } = usePermissions();
  const canCreateMateria = hasPermission("materias.crear");
  const canUpdateMateria = hasPermission("materias.actualizar");
  const canDeleteMateria = hasPermission("materias.eliminar");

  const {
    materias,
    busqueda,
    setBusqueda,
    pagina,
    setPagina,
    totalFiltradas,
    totalPaginas,
    porPagina,
    loading,
    listError,
    lastUpdated,
    resumen,
    filtro,
    modal,
    materiaSeleccionada,
    formNuevo,
    setFormNuevo,
    formEditar,
    setFormEditar,
    savingNuevo,
    savingEditar,
    deleting,
    fetchMaterias,
    abrirModalNuevo,
    abrirModalEditar,
    abrirModalEliminar,
    cerrarModal,
    handleCrearMateria,
    handleActualizarMateria,
    handleEliminarMateria,
    aplicarFiltro,
  } = useMateriaLogic();

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (modal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modal]);

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronización inicial";

  return (
    <section className="management-page management-theme-blue materias-wrapper">
      <CoordinacionTabs />
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Académico</p>
          <h4 className="management-title mb-1">Materias</h4>
          <p className="text-muted mb-0">
            Administra las materias que forman parte del catálogo académico.
          </p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreateMateria && (
            <button
              type="button"
              className="btn management-btn-primary"
              onClick={abrirModalNuevo}
            >
              <i className="bi bi-plus-circle me-2" />
              Nueva materia
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <MateriasSummary
        resumen={resumen}
        onQuickFilter={aplicarFiltro}
        activeKey={filtro}
      />

      {listError && (
        <div className="management-alert d-flex align-items-center justify-content-between gap-3 flex-wrap">
          <div>
            <p className="mb-0">{listError}</p>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={fetchMaterias}
          >
            <i className="bi bi-arrow-repeat me-2" />
            Reintentar
          </button>
        </div>
      )}

      <MateriasList
        materias={materias}
        loading={loading}
        reload={fetchMaterias}
        onEdit={canUpdateMateria ? abrirModalEditar : undefined}
        onDelete={canDeleteMateria ? abrirModalEliminar : undefined}
        canEdit={canUpdateMateria}
        canDelete={canDeleteMateria}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        pagina={pagina}
        setPagina={setPagina}
        totalFiltradas={totalFiltradas}
        totalPaginas={totalPaginas}
        porPagina={porPagina}
      />

      <MateriasFormModal
        modal={modal}
        formNuevo={formNuevo}
        setFormNuevo={setFormNuevo}
        formEditar={formEditar}
        setFormEditar={setFormEditar}
        savingNuevo={savingNuevo}
        savingEditar={savingEditar}
        deleting={deleting}
        materiaSeleccionada={materiaSeleccionada}
        cerrarModal={cerrarModal}
        handleCrearMateria={handleCrearMateria}
        handleActualizarMateria={handleActualizarMateria}
        handleEliminarMateria={handleEliminarMateria}
        canUpdate={canUpdateMateria}
        canDelete={canDeleteMateria}
      />
    </section>
  );
}
